/**
 * @generated SignedSource<<eeff58bf5eb26d27cd35b01543f2d1b9>>
 * @relayHash 40b30a8fa0be75685234f27c71cbf5c2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d9ab76076e17c90ecc071457570aec8bc4adb1b24fcf2555726ea0b25f76a75a

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ServiceHubsPageQuery } from './ServiceHubsPageQuery.graphql';

const node: PreloadableConcreteRequest<ServiceHubsPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "d9ab76076e17c90ecc071457570aec8bc4adb1b24fcf2555726ea0b25f76a75a",
    "metadata": {},
    "name": "ServiceHubsPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
